export type ThemePreference = 'light' | 'dark' | 'system';
export type ResolvedTheme = 'light' | 'dark';

export const THEME_STORAGE_KEY = 'enter-theme';
/** 访客站点与主站账号的主题互不影响，用独立 key。 */
export const PUBLIC_SITE_THEME_STORAGE_KEY = 'enter-public-site-theme';
export const SYSTEM_THEME_QUERY = '(prefers-color-scheme: dark)';

export function parseThemePreference(value: string | null): ThemePreference {
    return value === 'dark' || value === 'system' ? value : 'light';
}

export function resolveTheme(preference: ThemePreference, system: ResolvedTheme, forced?: ResolvedTheme): ResolvedTheme {
    return forced ?? (preference === 'system' ? system : preference);
}
